import { useEffect } from 'react';
import type { Map as MapTypes, GeoJSONSource } from 'mapbox-gl';

interface useHotelsLayerProps {
  hotelsList: GeoJSON.Feature[];
  mapbox?: MapTypes;
}

/**
 * Когда стили карты загружены, наносим список отелей
 */
export const useHotelsLayer = (props: useHotelsLayerProps): void => {
  const { mapbox, hotelsList } = props;

  useEffect(() => {
    if (mapbox) {
      const hotelsData: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
        type: 'FeatureCollection',
        features: hotelsList,
      };

      const hotelSource = mapbox.getSource('hotels') as GeoJSONSource;
      hotelSource.setData(hotelsData);
    }
  }, [hotelsList, mapbox]);
};
